const COOKIE_NAME = __RUNTIME.authCookie;
const COOKIE_DOMAIN =
  __RUNTIME.mode === 'production'
    ? '.chessopen.ru'
    : __RUNTIME.mode === 'staging'
      ? '.stg.chessopen.ru'
      : '';

export class AuthCookie {
  #cachedValue: number | 'NONE' | undefined;

  private constructor() {
    this.syncFromCookie();
  }

  get chessOpenId(): number | 'NONE' | undefined {
    return this.#cachedValue;
  }

  syncFromCookie(): void {
    this.#cachedValue = this.#readFromCookie();
  }

  setLoggedOut(): void {
    const domain = COOKIE_DOMAIN ? `domain=${COOKIE_DOMAIN}; ` : '';
    const secure = COOKIE_DOMAIN ? '; Secure' : '';
    document.cookie = `${COOKIE_NAME}=NONE; ${domain}path=/; SameSite=Lax${secure}`;
    this.#cachedValue = 'NONE';
  }

  #readFromCookie(): number | 'NONE' | undefined {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]+)`));
    if (!match) return undefined;
    if (match[1] === 'NONE') return 'NONE';
    return Number(match[1]);
  }

  static #instance?: AuthCookie;

  static get instance(): AuthCookie {
    if (!this.#instance) {
      this.#instance = new AuthCookie();
    }

    return this.#instance;
  }
}
